module.exports = __webpack_public_path__ + "static/media/fonticons.4ccd414e.svg";